import { render, staticRenderFns } from "./DeleteForms.vue?vue&type=template&id=44341e44"
import script from "./DeleteForms.vue?vue&type=script&lang=js"
export * from "./DeleteForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports